import { render, staticRenderFns } from "./StaffSupport.vue?vue&type=template&id=7151c88e"
import script from "./StaffSupport.vue?vue&type=script&lang=js"
export * from "./StaffSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports